import { Component, type ErrorInfo, type ReactNode } from 'react';

import { Button } from '../components/Button';
import { EmptyState } from '../components/EmptyState';
import { humanizeError } from '../lib/errors';
import { logger } from '../lib/logger';
import styles from './ErrorBoundary.module.css';

type ErrorBoundaryState = {
  readonly error: unknown;
};

/** Ошибки — человеческим языком, с действием «Повторить» (docs/06 §5.6). */
export class ErrorBoundary extends Component<{ readonly children: ReactNode }, ErrorBoundaryState> {
  override state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    return { error };
  }

  override componentDidCatch(error: unknown, info: ErrorInfo): void {
    logger.warn('необработанная ошибка UI', error, info.componentStack);
  }

  override render(): ReactNode {
    const { error } = this.state;
    if (error === null) {
      return this.props.children;
    }
    const human = humanizeError(error);
    return (
      <div className={styles['wrap']}>
        <EmptyState
          icon={<span>!</span>}
          title={human.message}
          description="Повторите действие. Если ошибка повторяется, передайте код поддержке."
          action={
            <div className={styles['actions']}>
              <Button variant="primary" onClick={() => this.setState({ error: null })}>
                Повторить
              </Button>
              <Button variant="ghost" onClick={() => window.location.assign('/')}>
                К проектам
              </Button>
            </div>
          }
        />
        <p className={styles['code']}>Код: {human.code}</p>
      </div>
    );
  }
}
